import React, { useState } from "react";


import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

function Agreement() {
    return (

            <Container
                component="main"
                sx={{ marginTop: 2, marginBottom: 2 }}
                maxWidth="xl"
            >
                <Typography>
                    Соглашение для обработки персональных данных и политика
                    конфиденциальности
                </Typography>
                <br />
                <Typography>
                    СОГЛАШЕНИЕ ДЛЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ И ПОЛИТИКА
                    КОНФИДЕНЦИАЛЬНОСТИ
                </Typography>
                <br />
                <Typography>
                    Присоединяясь к настоящему Соглашению и оставляя свои данные на сайте
                    https://gto.moscow.sport, (далее – Сайт), путем заполнения полей в
                    Личном кабинете (регистрации), Пользователь:
                </Typography>
                <br />
                <Typography>
                    1. Подтверждает, что все указанные им данные принадлежат лично ему;
                </Typography>
                <Typography>
                    2. Подтверждает и признает, что им внимательно в полном объеме
                    прочитано Соглашение и условия обработки его персональных данных,
                    указываемых им в полях регистрации в Личном кабинете (регистрации),
                    текст соглашения и условия обработки персональных данных ему понятны;
                </Typography>
                <Typography>
                    3. Дает согласие на обработку Сайтом предоставляемых в составе
                    информации персональных данных в целях заключения между ним и Сайтом
                    настоящего Соглашения, а также его последующего исполнения;
                </Typography>
                <Typography>
                    4. Выражает согласие с условиями обработки персональных данных без
                    оговорок и ограничений.
                </Typography>
                <br />
                <Typography>
                    Пользователь дает свое согласие на обработку его персональных данных,
                    а именно совершение действий, предусмотренных п. 3 ч. 1 ст. 3
                    Федерального закона от 27.07.2006 N 152-ФЗ "О персональных данных", и
                    подтверждает, что, давая такое согласие, он действует свободно, своей
                    волей и в своем интересе.
                </Typography>
                <br />
                <Typography>
                    Согласие Пользователя на обработку персональных данных является
                    конкретным, информированным и сознательным.
                </Typography>
                <br />
                <Typography>
                    Настоящее согласие Пользователя признается исполненным в простой
                    письменной форме, на обработку следующих персональных данных: фамилии,
                    имени, отчества; номерах телефонов; адресах электронной почты
                    (E-mail).
                </Typography>
                <br />
                <Typography>
                    Пользователь, предоставляет Сайту право осуществлять следующие
                    действия (операции) с персональными данными: сбор и накопление;
                    хранение в течение установленных нормативными документами сроков
                    хранения отчетности, но не менее трех лет, с момента даты прекращения
                    пользования услуг Пользователем; уточнение (обновление, изменение);
                    использование; уничтожение; обезличивание; передача по требованию
                    суда, в т.ч., третьим лицам, с соблюдением мер, обеспечивающих защиту
                    персональных данных от несанкционированного доступа.
                </Typography>
                <br />
                <Typography>
                    Указанное согласие действует бессрочно с момента предоставления данных
                    и может быть отозвано Пользователем путем подачи заявления
                    администрации сайта с указанием данных, определенных ст. 14 Закона «О
                    персональных данных».
                </Typography>
                <br />
                <Typography>
                    Отзыв согласия на обработку персональных данных может быть осуществлен
                    путем направления Пользователем соответствующего распоряжения в
                    простой письменной форме на адрес электронной почты (E-mail)
                    info@mossport.info
                </Typography>
                <br />
                <Typography>
                    Сайт не несет ответственности за использование (как правомерное, так и
                    неправомерное) третьими лицами Информации, размещенной Пользователем
                    на Сайте, включая её воспроизведение и распространение, осуществленные
                    всеми возможными способами.
                </Typography>
                <br />
                <Typography>
                    Сайт имеет право вносить изменения в настоящее Соглашение. При
                    внесении изменений в актуальной редакции указывается дата последнего
                    обновления. Новая редакция Соглашения вступает в силу с момента ее
                    размещения, если иное не предусмотрено новой редакцией Соглашения.
                </Typography>
                <br />
                <Typography>
                    К настоящему Соглашению и отношениям между пользователем и Сайтом,
                    возникающим в связи с применением Соглашения подлежит применению право
                    Российской Федерации.
                </Typography>
                <br />
                <Typography>СОГЛАСИЕ НА ПОЛУЧЕНИЕ РАССЫЛОК</Typography>
                <br />
                <Typography>
                    Подписываясь на SMS- и email-рассылку Региональной сети правовой
                    поддержки «ANO MOSSPORT» (далее – «MOSSPORT») или третьих лиц,
                    уполномоченных на рассылку от имени «MOSSPORT», в сети Интернет
                    https://gto.moscow.sport, я соглашаюсь получать информационную
                    рассылку на телефон и электронный адрес, указанный мной при подписке
                    через сервис подписки информационной рассылки на сайте
                    https://gto.moscow.sport.
                </Typography>
                <br />
                <Typography>
                    Я проинформирован о том, что в случае, если у меня возникнет желание
                    отказаться от информационной рассылки https://gto.moscow.sport, мне
                    будет необходимо самостоятельно перейти по ссылке «Отписаться от
                    рассылки», указанной в тексте отправляемых сайтом сообщений с
                    электронного адреса info@mossport.info или же удалить признак моего
                    согласия на получение информационных рассылок в Личном Кабинете на
                    сайте https://gto.moscow.sport.
                </Typography>
                <br />
                <Typography>
                    Я также ознакомлен с нижеизложенным Пользовательским соглашением и даю
                    разрешение «MOSSPORT» или третьим лицам, уполномоченным на рассылку от
                    имени «MOSSPORT», собирать, хранить и обрабатывать все переданные мною
                    в адрес «MOSSPORT» мои персональные данные (в том числе фамилию, имя,
                    отчество и адрес электронной почты, номер телефона) с целью
                    информирования о новостях и других событиях «MOSSPORT». С правами,
                    возникающими в связи с обработкой моих персональных данных, и целями
                    обработки и использования моих персональных данных ознакомлен.
                </Typography>
                <br />
                <Typography>Пользовательское соглашение</Typography>
                <br />
                <Typography>
                    Настоящее Пользовательское соглашение регулирует отношения между
                    Пользователем и «MOSSPORT» (в том числе третьими лицами,
                    уполномоченными на рассылку от имени «MOSSPORT») в части получения
                    Пользователем информационной рассылки с сайта
                    https://gto.moscow.sport.и определяет порядок и условия получения
                    информационной рассылки сайта https://gto.moscow.sport.
                </Typography>
                <br />
                <Typography>
                    Давая согласие на получение информационной рассылки, Пользователь
                    выражает согласие со следующими условиями:
                </Typography>
                <Typography>
                    1. Пользователь самостоятельно несет ответственность за сохранение и
                    обеспечение сохранности своего номера мобильного телефона и адреса
                    электронной почты при заполнении формы подписки, запрашиваемой сайтом
                    https://gto.moscow.sport.
                </Typography>
                <Typography>
                    2. Пользователь самостоятельно несет обязательства при изменении
                    номера мобильного телефона или адреса электронной почты производить
                    замену, внося соответствующие изменения в форму подписки на сайте.
                </Typography>
                <Typography>
                    3. Пользователь несет полную ответственность за любые действия,
                    совершенные им или третьими лицами, которым он предоставил данные с
                    номером мобильного телефона или адресом электронной почты, в том числе
                    при использовании чужого номера телефона для регистрации, а также за
                    любые последствия, которые могло повлечь или повлекло подобное их
                    использование.
                </Typography>
                <Typography>
                    4. Подписка на получение информационной рассылки, а также получение
                    самой информационной рассылки является бесплатной.
                </Typography>
                <Typography>
                    5. «MOSSPORT» оставляет за собой право по своему усмотрению
                    приостанавливать, ограничивать или прекращать доступ Пользователю к
                    получению им информационной рассылки, на которую он подписан, в любое
                    время по любой причине или без объяснения причин, с предварительным
                    уведомлением или без такового.
                </Typography>
                <Typography>
                    6. Пользователь несет личную ответственность за всю информацию о
                    номере мобильного телефона и адресе электронной почты, которые он
                    размещает в форме подписке на сайте https://gto.moscow.sport подписке
                    на информационную рассылку сайта.
                </Typography>
                <Typography>
                    7. В случае, если Пользователь решит удалить свои данные, отказавшись
                    от информационной рассылки, «MOSSPORT» имеет право сохранять архивные
                    резервные копии всех персональных данных Пользователя.
                </Typography>
                <Typography>
                    8. «MOSSPORT», а также третьи лица, уполномоченные на рассылку от
                    имени «MOSSPORT», не несут ответственности за любые ошибки, упущения,
                    прерывания, удаление, дефекты, задержку в обработке или передаче SMS-
                    или email-сообщений с информационной рассылкой. «MOSSPORT», а также
                    третьи лица, уполномоченные на рассылку от имени «MOSSPORT», не
                    отвечают за любые технические сбои или иные проблемы любых телефонных
                    сетей или служб, компьютерных систем, серверов или провайдеров,
                    компьютерного оборудования, программного обеспечения, сбоев сервисов.
                </Typography>
                <Typography>
                    9. «MOSSPORT», а также третьи лица, уполномоченные на рассылку от
                    имени «MOSSPORT», подтверждают сохранение в тайне и непредоставление
                    третьим лицам персональных данных Пользователя, оставленных им при
                    подписке на получение информационной рассылки сайта
                    https://gto.moscow.sport.
                </Typography>
                <Typography>
                    10. Вся информация, содержащаяся в настоящем Пользовательском
                    соглашении, является полностью конфиденциальной, и Пользователь
                    обязуется соблюдать конфиденциальность всех положений настоящего
                    Пользовательского соглашения таким образом и с таким усердием, как
                    Пользователь соблюдает конфиденциальность собственной конфиденциальной
                    информации. Пользователь принимает на себя любые расходы, убытки,
                    требования и/или иски третьих лиц, поданные в отношении «MOSSPORT» в
                    связи с нарушением конфиденциальности Пользователем указанных
                    требований о конфиденциальности.
                </Typography>
            </Container>
    );
}

export default Agreement;
